module.exports = __webpack_public_path__ + "static/media/default-food-type.78eff812.svg";